import { RECORDING_START_FAILED_BODY } from '@/lib/recording-ui-messages';
import type { RecordingUiState } from '@/lib/recording-status-client';

export const RECORDING_START_FAILED_EVENT = 'recording:start-failed';

const RECENT_START_FAILURE_MS = 2 * 60_000;

let awaitingDismissedAt = 0;

/** Cancelamento ou parada feita por alguém na sala — não tratar o idle seguinte como falha. */
export function markRecordingAwaitingDismissedByUser(now = Date.now()) {
  awaitingDismissedAt = now;
}

export function consumeRecordingAwaitingDismissedByUser(now = Date.now()): boolean {
  if (!awaitingDismissedAt) return false;
  const recent = now - awaitingDismissedAt < 8_000;
  awaitingDismissedAt = 0;
  return recent;
}

export function isRecordingStartFailureMessage(message?: string | null): boolean {
  if (!message) return false;
  const text = message.toLowerCase();
  if (text.includes('interrompida') || text.includes('inesperadamente')) return false;
  return (
    text.includes('não chegou') ||
    text.includes('nao chegou') ||
    text.includes('não foi possível iniciar') ||
    text.includes('nao foi possivel iniciar') ||
    text.includes('não começou') ||
    text.includes('nao comecou') ||
    text.includes('prepare timeout') ||
    text.includes('start signal') ||
    text.includes('egress start failed') ||
    text.includes('sem mídia') ||
    text.includes('sem midia') ||
    text.includes('tente novamente') ||
    text.includes('tente de novo')
  );
}

export function shouldAnnounceRecordingStartFailure(input: {
  previous: RecordingUiState;
  message?: string | null;
  fromSnapshot?: boolean;
  updatedAt?: string | null;
  now?: number;
}): boolean {
  const message = input.message ?? '';
  if (message.includes('api_transient') || /no response from servers/i.test(message)) {
    return false;
  }
  if (input.previous === 'active') return false;
  if (input.previous === 'preparing' || input.previous === 'starting') return true;
  if (!isRecordingStartFailureMessage(message)) return false;
  if (!input.fromSnapshot) return true;

  const at = input.updatedAt ? Date.parse(input.updatedAt) : NaN;
  if (!Number.isFinite(at)) return false;
  return (input.now ?? Date.now()) - at < RECENT_START_FAILURE_MS;
}

/** Aviso para todos os clientes da sala. Fica aberto até o clique. */
export function announceRecordingStartFailed(message?: string) {
  if (typeof window === 'undefined') return;
  const text = message?.trim() || RECORDING_START_FAILED_BODY;
  window.dispatchEvent(
    new CustomEvent(RECORDING_START_FAILED_EVENT, { detail: { message: text } }),
  );
}
